import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export interface SiteFlags {
  beta: boolean
}

export const siteApi = createApi({
  reducerPath: 'siteApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1' }),
  endpoints: (builder) => ({
    getSiteFlags: builder.query<SiteFlags, void>({
      query: () => '/site/flags',
      transformResponse: (response: { data: SiteFlags }) => response.data,
    }),
  }),
})

export const { useGetSiteFlagsQuery } = siteApi
